import script from "./TempHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TempHomePage.vue?vue&type=script&setup=true&lang=js"

import "./TempHomePage.vue?vue&type=style&index=0&id=5b1fc374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1fc374"]])

export default __exports__